import React from "react";
import { Button, Card, Container, Form } from "react-bootstrap";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { login } from "../redux/actions/authActions";

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);

  const from = location.state?.from?.pathname || "/categories";

  if (isAuthenticated) return <Navigate to={from} replace />;

  return (
    <div className="page page-center">
      <Container className="container-tight py-4">
        <Card>
          <Card.Body>
            <h2 className="h2 text-center mb-4">Login</h2>
            <Formik
              initialValues={{ email: "", password: "" }}
              onSubmit={async (values, { setFieldError }) => {
                try {
                  await dispatch(login(values));
                  navigate(from, { replace: true });
                } catch (err) {
                  setFieldError("password", err.message || "Login failed");
                }
              }}
            >
              {({ values, handleChange, handleSubmit, isSubmitting, errors }) => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      name="email"
                      type="email"
                      value={values.email}
                      onChange={handleChange}
                      autoComplete="email"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      type="password"
                      autoComplete="current-password"
                      isInvalid={!!errors.password}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Button className="w-100" type="submit" disabled={isSubmitting}>
                    Sign in
                  </Button>
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

